module.exports = __webpack_public_path__ + "static/media/suggestion-multimedia.c8aa8b34.png";